import { Suspense } from 'react';
import type { MeshBasicMaterialProps } from '@react-three/fiber';
import { useDeviceImage } from 'modules/editor/hooks/useDeviceTexture';

type Props = MeshBasicMaterialProps & { imageUrl: string };

function LoadedDeviceImageMaterial({ imageUrl, ...props }: Props) {
  const texture = useDeviceImage(imageUrl);
  return <meshBasicMaterial {...props} map={texture} />;
}

export function DeviceImageMaterial({ imageUrl, ...props }: Props) {
  // Keep the device geometry and the rest of the editor visible while its image loads or retries.
  return (
    <Suspense fallback={<meshBasicMaterial {...props} />}>
      <LoadedDeviceImageMaterial imageUrl={imageUrl} {...props} />
    </Suspense>
  );
}
